import React, { useRef } from "react";
import "./RessourceCard.scss";
import {
  FaFile,
  FaDownload,
  FaClone,
  FaPlayCircle,
  FaFilePowerpoint,
  FaTrash,
} from "react-icons/fa";
import BtnBleu from "../../Boutons/BtnBleu/btn-bleu";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { updateRessources } from "Redux/Actions/ressourcesActions";
import axios from "axios";
import { Toast } from "primereact/toast";

/**
 * Permet d'afficher une card de ressource
 */
const RessourceCard = (props) => {
  const cancelToast = useRef(null);

  const deleteRessource = () => {
    let url = `${process.env.REACT_APP_BASE_URL_API}/resources/${props.dataRessource.id}`;
    axios
      .delete(url, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then(() => {
        props.handleUpdateRessources({
          ressourcesData: props.ressources.ressourcesData.filter(
            (ressource) => ressource.id !== props.dataRessource.id
          ),
        });
        cancelToast.current.show({
          severity: "error",
          summary: "error : ",
          detail: "La ressource a bien été supprimée",
          life: 3000,
        });
      })
      .catch((error) =>
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        })
      );
  };

  const downloadRessource = () => {
    let url = `${process.env.REACT_APP_BASE_URL_API}/resources/${props.dataRessource.id}/download`;
    fetch(url, {
      method: "GET",
    })
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(
          new Blob([blob], { type: "application/pdf" })
        );
        link.setAttribute("download", `${props.dataRessource.name}`);
        link.click();
      });
  };
  return (
    <div className="ressource cardHover">
      <Toast ref={cancelToast} />
      <h2>
        {props.iconeConseil == 0 ? <FaFile /> : ""}
        {props.iconeConseil == 1 ? <FaClone /> : ""}
        {props.iconeConseil == 2 ? <FaPlayCircle /> : ""}
        {props.iconeConseil == 3 ? <FaFilePowerpoint /> : ""}
        {props.name}
      </h2>
      {props.gestion ? (
        <div className="ressource__right gestion">
          PDF {props.size} MB{" "}
          <FaTrash
            onClick={() => {
              deleteRessource();
            }}
          />
          {/* TO DO : au clic sur l'icône poubelle, supprimer la ressource de la liste */}
        </div>
      ) : (
        <div className="ressource__right">
          PDF {props.size} MB{" "}
          <BtnBleu
            btnTexte="Télécharger "
            btnAction={() => {
              downloadRessource();
            }}
          >
            <FaDownload />
          </BtnBleu>{" "}
        </div>
      )}
    </div>
  );
};

RessourceCard.propTypes = {
  name: PropTypes.string,
  size: PropTypes.string,
  iconeConseil: PropTypes.number,
  gestion: PropTypes.bool,
  dataRessource: PropTypes.object,
  ressources: PropTypes.object,
  handleUpdateRessources: PropTypes.func,
  auth: PropTypes.object,
};

const mapStateToProps = (state) => ({
  ressources: state.ressources,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateRessources: (value) => {
    dispatch(updateRessources(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RessourceCard);
